import {  BaseTLTableBase, CountryService, Component, BaseTLTableComponent, AxiosResponse, tlISODateWithoutYearToLocalString, Prop, NationalHolidayFilter, NationalHolidayService, Vuex, Vue, tlPrepareForFilter, tlISODateToLocalString } from "../../../Infrastructure/CorBase/CoreBase";

		export default abstract class NationalHolidayListBase extends BaseTLTableComponent {		

			selectedState: string = '';

			items: any[] = [];
			nationalHolidayItems: any[] = [];
			nationalHolidayService: NationalHolidayService = new NationalHolidayService();
			countryService: CountryService = new CountryService();

			showAllertToDeleteClickBase(itemsSelected: any) {
				super.showAlertBeforeActionClickBase(itemsSelected, this.$t('nationalHoliday.messageQuestionMain').toString());
			}


			callActionClick() {
				this.isBusy = true;
				this.deleteItemsList = this.getSelectedList();
				super.deleteList();		
				
				this.itemsSelected = null;
				(this.$refs.nationalHolidayTable as BaseTLTableBase).clearSelected();
			}


			protected deleteListServer(): Promise<AxiosResponse<any>> {
				return this.nationalHolidayService.deleteList(this.deleteItemsList);
			}

			initNationalHolidays() {
				this.isBusy = true;
				this.nationalHolidayItems = [];
				this.countryEnums = [];

				 this.nationalHolidayService.getAll().then((response) => {
					this.items = response.data;
					for (var i = 0; i < this.items.length; i++) {

						if (this.countryEnums.filter(c => c.value == this.items[i].idCountryNavigationAlpha2).length == 0) {
							this.countryEnums.push({ value: this.items[i].idCountryNavigationAlpha2, text: this.items[i].idCountryNavigationName });
						}

						let validFrom = this.items[i].validFrom;
						let validTo = this.items[i].validTo;

						let dateOfHoliday = new Date(this.items[i].dayOfHoliday).toLocaleDateString(undefined, {month: "numeric", day: "numeric"});
						
						this.nationalHolidayItems.push({
							name: this.items[i].name,
							idCountry: this.items[i].idCountry,
							idCountryNavigationAlpha2: this.items[i].idCountryNavigationAlpha2,
							id: this.items[i].id, dayOfHoliday: dateOfHoliday
							, validFrom: validFrom, validTo: validTo,
							validTo2: this.items[i].validTo2, validFrom2: this.items[i].validFrom2
						});
					}

					 //nacteni filtrů
					 var fil = this.filters.filter(c => c.key == 'idCountryNavigationAlpha2')[0];
					 fil.useOwnEnumsSendArray = this.countryEnums;
				}).catch((error) => {
					this.isBusy = false;
					super.showErrorMessage(error);

				});

				this.isBusy = false;
			}	

			fetchDataFromServer(): Promise<AxiosResponse<any>> {
				return this.nationalHolidayService.getAll();
			}

			//zatím nepotrebujeme
			fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
				return this.fetchDataFromServer();
			}

			refreshItems(items: any[], refreshData: any[]) {
				return items;
			}

			protected prepareCountryEnum(): void {
				this.countryService.getAll().then(res => {
					this.countryEnums = [];
					for (var i = 0; i < res.data.length; i++) {
						this.countryEnums.push({ value: res.data[i].id, text: res.data[i].name });
					}
					this.setfilters(null);
				});
			}

			prepareItems(items: any[]) {
				// zde zatim nepotrebujeme
				for (var i = 0; i < items.length; i++) {
					items[i].validFrom2 = tlPrepareForFilter(items[i].validFrom);
					items[i].validTo2 = tlPrepareForFilter(items[i].validTo);
				}
			}
			
			setFields() {
				this.fields = [
					{ key: 'name', label: this.$t('nationalHoliday.fieldName'), trans: 'nationalHoliday.fieldName', sortable: true, class: 'text-left', design: 'detail' },
					//{ key: 'idCountry', label: 'stat', sortable: true, class: 'text-center' ,visible: false },
					{ key: 'idCountryNavigationAlpha2', label: 'Název stat ', sortable: true, class: 'text-left', show: false, optional: true},
					{ key: 'dayOfHoliday', label: this.$t('nationalHoliday.fieldDay'), trans: 'nationalHoliday.fieldDay', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateWithoutYearToLocalString(x) },
					{ key: 'validFrom', label: this.$t('nationalHoliday.fieldBegin'), trans: 'nationalHoliday.fieldBegin', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
					{ key: 'validTo', label: this.$t('nationalHoliday.fieldEnd'), trans: 'nationalHoliday.fieldEnd', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
					{ key: 'actions', label: this.$t('nationalHoliday.fieldActions'), trans: 'nationalHoliday.fieldActions', class: 'text-right', thClass: 'lastColumnTable' }
				]
			};

			//TODO nacist z datazaze
			countryEnums = [
				{ value: '1', text: this.$t('nationalHoliday.czechNational').toString() },
				{ value: '2', text: this.$t('nationalHoliday.slovakNational').toString() }];


			//filtry
			setfilters(value: any) {
				if (value != null && value[0].lang == this.filters[0].lang) {
					this.filters = value;
				}
				else {
					this.filters = [
						{ key: 'idCountry', label: this.$t('nationalHoliday.fieldState'), trans: 'nationalHoliday.fieldState', selected: true, value: '1', default: '1', type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.countryEnums, useEnum: true, refItem: 'idCountry', showAnyTime: true, lang: this.$store.state.currentLanguage },
						{ key: 'name', label: this.$t('nationalHoliday.filterName'), trans: 'nationalHoliday.filterName', selected: false, value: null, type: 'text' },
						{ key: 'validFrom2', label: 'Počátek platnosti od', selected: false, value: null, type: 'date', moreThan: true },
						{ key: 'validTo2', label: 'Konec platnosti do', selected: false, value: null, type: 'date', moreThan: false }
					];
				}
			}

			getOptionalParams() {
				return { idCountry: String(this.filters.filter((c: any) => c.key == 'idCountry')[0].value) };
			}
		

		};
